(function () {
  'use strict';

  angular.module('app').component('hotelPage', HotelPageComponent());

  function HotelPageComponent() {
    return {
      bindings: {},
      controller: HotelDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotels/hotel-page.component.html',
    };
  }

  HotelDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'HotelService',
    'LanguageService',
  ];

  function HotelDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    HotelService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_hotel_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    // Methods
    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Initializers
    // getHotel();
    getAdditionalLanguages();

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getHotel();
      });
    }

    function getHotel() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        HotelService.getHotel(itemId, { lang: vm.defaultLanguage, show_contents: true }).then(
          function (data) {
            vm.item = data;

            vm.loadingItem = false;
          }
        );
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/hotels/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/hotels');
    }
  }
})();
